import React from "react";
import ButtonDisable from "../../partials/other/ButtonDisable";
import userExample from "../user/UserExample";
import helperNumbers from "../../../helpers/numbers";

function MobileUser() {
  return (
    <>
      <section className="content">
        <div className="card">
          <div className="card-body d-flex flex-column">
            <div className="d-flex flex-row">
              <div className="pl-2">
                <span>
                  <i className="fas fa-check-circle text-success"></i>
                </span>
              </div>
              <div>
                <div>
                  <p className="m-0">
                    <span>کاربر محترم</span>{" "}
                  </p>
                </div>
                <div className="pt-3">
                  <span>شماره همراه : </span>
                  <span dir="ltr">
                    {helperNumbers.toPersianNum(
                      helperNumbers.presentMobileNumber(userExample.mobile)
                    )}
                  </span>
                </div>
                <div className="pt-3 d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center justify-content-between">
                    <span>
                      <p className="m-0">
                        شماره همراه شما از قبل تایید شده است.
                      </p>
                    </span>
                  </div>
                  <span>
                    <ButtonDisable
                      buttonTagHtml={
                        <button className="btn btn-primary opacity-50">
                          ویرایش شماره موبایل
                        </button>
                      }
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default MobileUser;
